const formatAmount = (value, currency = 'USD') => {
  const valueRounded = Math.round((value || 0) * 100) / 100;
  let currencySymbol;
  if (currency === 'EUR') {
    currencySymbol = '€';
  } else {
    currencySymbol = '$';
  }
  return valueRounded >= 0 ? `${currencySymbol}${valueRounded.toFixed(2)}` : `(${currencySymbol}${-1 * valueRounded.toFixed(2)})`;
}

export default formatAmount;



// WEBPACK FOOTER //
// ./src/utils/formatAmount.js